import { Outlet, useNavigate } from 'react-router-dom';
import { Languages, LogOut, UserRound } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import ThemeSwitcher from '../components/ThemeSwitcher';

export default function UserLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleLogout = () => { logout(); navigate('/login'); };
  const lang = i18n.resolvedLanguage ?? i18n.language;
  const toggleLang = () => i18n.changeLanguage(lang === 'ru' ? 'en' : 'ru');

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="topbar-inner">
          <button type="button" className="brand" onClick={() => navigate('/')} aria-label={t('navbar.dashboard')}>
            <img className="brand-logo" src="/logo.png" alt="" />
            <span className="brand-copy">
              <span className="brand-name">Geek Automation System</span>
              <span className="brand-context">Cloud</span>
            </span>
          </button>

          <div className="topbar-actions">
            <ThemeSwitcher compact />
            <button type="button" className="icon-btn" onClick={toggleLang} title={t('common.switchLanguage')} aria-label={t('common.switchLanguage')}>
              <Languages className="icon-lg" aria-hidden="true" />
            </button>
            <button type="button" className="user-chip btn btn-outline-secondary" onClick={() => navigate('/profile')} title={t('userLayout.profile')}>
              <span className="avatar"><UserRound className="icon" aria-hidden="true" /></span>
              <span className="user-meta">
                <span className="user-name">{user?.username}</span>
                <span className="user-role">{t('userLayout.profile')}</span>
              </span>
            </button>
            <button type="button" className="icon-btn" onClick={handleLogout} title={t('userLayout.logout')} aria-label={t('userLayout.logout')}>
              <LogOut className="icon-lg" aria-hidden="true" />
            </button>
          </div>
        </div>
      </header>
      <main className="app-content"><Outlet /></main>
    </div>
  );
}
